module.exports = __webpack_public_path__ + "static/3-0721badd738c1ef3f234d20caa91bc60.jpeg";